<template>
	<div>
		<div class="wrap_page" v-loading="loading">
			<div class="text">基本信息</div>
			<el-form
				:model="param"
				:rules="rules"
				ref="ruleForm"
				label-width="35%"
				label-position="right"
			>
				<el-row
					type="flex"
					class="row-bg flex-wrap"
					justify="space-between"
					style="margin-right: 100px"
				>
					<el-col :span="12">
						<el-form-item label="项目名称：" prop="bo.projectName">
							<el-input
								minlength="20"
								placeholder="请输入"
								v-model="param.bo.projectName"
								@input="handInput"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="项目编号：" prop="bo.projectNumber">
							<el-input
								minlength="20"
								placeholder="项目编号为空时自动生成"
								v-model="param.bo.projectNumber"
								@input="handInput"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="项目类型：" prop="bo.projectType">
							<el-select v-model="param.bo.projectType">
								<el-option
									v-for="item in projectTypes"
									:key="item.value"
									:value="item.value"
									:label="item.label"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="研发周期：" required prop="bo.dateRange">
							<el-date-picker
								v-model="param.bo.dateRange"
								type="daterange"
								value-format="yyyy-MM-dd"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
							>
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否研发项目：" prop="bo.whetherRdProject">
							<el-select v-model="param.bo.whetherRdProject">
								<el-option
									v-for="item in options"
									:label="item.label"
									:value="item.value"
									:key="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="技术领域：" prop="bo.tecFieldThird">
							<el-cascader
								:options="tecOptions"
								style="width:100%;"
								v-model="tecChecked"
							></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="项目总预算金额：" prop="bo.projectBudget">
							<el-input
								type="number"
								placeholder="请输入"
								maxlength="20"
								minlength="1"
								v-model="param.bo.projectBudget"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="其中财政预算金额：" prop="bo.financialBudget">
							<el-input
								type="number"
								placeholder="请输入"
								maxlength="20"
								minlength="1"
								v-model="param.bo.financialBudget"
							></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row
					type="flex"
					class="row-bg flex-wrap"
					justify="space-between"
					style="margin-right: 100px"
					v-show="param.bo.projectType != 1"
				>
					<el-col :span="12">
						<el-form-item label="合同名称" prop="bo.contractName">
							<el-input
								placeholder="请输入"
								v-model="param.bo.contractName"
								@input="handInput"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item
							label="技术市场备案号"
							prop="bo.tecMarketRecordNumber"
						>
							<el-input
								placeholder="请输入"
								v-model="param.bo.tecMarketRecordNumber"
								@input="handInput"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="合同金额" prop="bo.contractMoney">
							<el-input
								placeholder="请输入"
								v-model="param.bo.contractMoney"
								@input="handInput"
							></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="委托机构/个人" prop="bo.delegateObjectt">
							<el-select v-model="param.bo.delegateObjectt">
								<el-option
									v-for="item in ObjectOptions"
									:label="item.label"
									:key="item.value"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="委托境内/境外" prop="bo.delegateArea">
							<el-select v-model="param.bo.delegateArea">
								<el-option
									v-for="item in AreaOptions"
									:label="item.label"
									:key="item.value"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="与委托方关联关系" prop="bo.delegateRelation">
							<el-select v-model="param.bo.delegateRelation">
								<el-option
									v-for="item in RelationOptions"
									:label="item.label"
									:key="item.value"
									:value="item.value"
								></el-option>
							</el-select>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>

		<div class="wrap_page" style="margin-top: 20px" v-loading="loading">
			<div slot="tip" class="el-upload__tip"></div>
			<div class="text">
				材料附件(
				附件说明：附件最多可上传5个文件，单个文件大小不超过10M，格式为PDF，DOC，DOCX)
			</div>

			<div style="margin-left: 100px">
				<p>1、研发项目计划书</p>
				<el-upload
					class="upload-demo"
					:action="uploadImgUrl"
					:on-preview="handleView"
					:before-upload="beforeUploadZjtx"
					:on-remove="handleRemove"
					:on-success="uploadSuccess"
					:before-remove="beforeRemove"
					:on-error="uploadError"
					:limit="5"
					:on-exceed="handleExceed"
					:data="{ moduleType: 37 }"
					:file-list="fileList37"
				>
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip"></div>
				</el-upload>
				<p>2、研发项目决议书</p>
				<el-upload
					class="upload-demo"
					:action="uploadImgUrl"
					:on-preview="handleView"
					:before-upload="beforeUploadZjtx"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:on-success="uploadSuccess"
					:limit="5"
					:data="{ moduleType: 38 }"
					:on-exceed="handleExceed"
					:file-list="fileList38"
					:on-error="uploadError"
				>
					<el-button size="small" type="primary">点击上传</el-button>
				</el-upload>
				<p>3、合同</p>
				<el-upload
					class="upload-demo"
					:action="uploadImgUrl"
					:on-preview="handleView"
					:before-upload="beforeUploadZjtx"
					:on-remove="handleRemove"
					:before-remove="beforeRemove"
					:data="{ moduleType: 39 }"
					:limit="5"
					:on-success="uploadSuccess"
					:on-exceed="handleExceed"
					:file-list="fileList39"
					:on-error="uploadError"
				>
					<el-button size="small" type="primary">点击上传</el-button>
				</el-upload>
			</div>
		</div>

		<div class="flex flex-center" style="margin-top:20px;" v-loading="loading">
			<el-button type="primary" @click="save()">保存</el-button>
			<el-button type="primary" @click="nextStep()">下一步</el-button>
		</div>
	</div>
</template>

<script>
import { getDict } from "@/api/ChinaHigh";
import { getCascadeDictData, saveProject, getProject } from "./project";
import { getMultiFiles } from "@/api/specialization";
export default {
	data() {
		return {
			loading: false,
			ruleForm: {
				name: ""
			},
			projectTypes: [
				{ label: "自主研发", value: 1 },
				{ label: "委托研发", value: 2 },
				{ label: "合作研发", value: 3 },
				{ label: "集中研发", value: 4 }
			],
			options: [
				{ label: "是", value: 1 },
				{ label: "否", value: 2 }
			],
			ObjectOptions: [
				{ label: "机构", value: 1 },
				{ label: "个人", value: 2 }
			],
			AreaOptions: [
				{ label: "境内", value: 1 },
				{ label: "境外", value: 2 }
			],
			RelationOptions: [
				{ label: "存在", value: 1 },
				{ label: "不存在", value: 2 }
			],
			tecChecked: [],
			rules: {
				"bo.projectName": [
					{ required: true, message: "请输入", trigger: "blur" },
					{ min: 1, max: 20, message: "长度在 1 到 20 个字符", trigger: "blur" }
				],
				"bo.projectType": [
					{ required: true, message: "请选择", trigger: "change" }
				],
				"bo.dateRange": [
					{ required: true, message: "请选择", trigger: "change" }
				],
				"bo.whetherRdProject": [
					{ required: true, message: "请选择", trigger: "change" }
				],
				"bo.tecOptions": [
					{ required: true, message: "请选择", trigger: "change" }
				],
				"bo.projectBudget": [
					{ required: true, message: "请输入", trigger: "blur" }
				],
				"bo.financialBudget": [
					{ required: true, message: "请输入", trigger: "blur" }
				],
				"bo.delegateObjectt": [
					{ required: true, message: "请选择", trigger: "change" }
				],
				"bo.delegateArea": [
					{ required: true, message: "请选择", trigger: "change" }
				],
				"bo.delegateRelation": [
					{ required: true, message: "请选择", trigger: "change" }
				]
			},
			tecOptions: [],
			param: {
				bo: {
					dateRange: [],
					projectType: 1,
					projectName: "",
					projectNumber: "",
					startTime: "",
					endTime: "",
					tecFieldFirst: 0,
					tecFieldSecond: 0,
					tecFieldThird: 0,
					whetherRdProject: 1,
					projectBudget: 1,
					financialBudget: 1,
					contractName: "",
					contractMoney: 0,
					delegateArea: 1,
					delegateObjectt: 1,
					delegateRelation: 1,
					tecMarketRecordNumber: ""
				},
				fileBindVOList: []
			},
			fileItem: {
				name: "",
				moduleType: 0,
				response: {
					data: {}
				}
			},
			fileList37: [],
			fileList38: [],
			fileList39: []
		};
	},
	created() {
		this.init();
	},
	methods: {
		handInput(index, item) {
			if (index.length >= 20) {
				this.$message({
					message: "最大长度为20个字符",
					type: "error"
				});
			}
		},
		save() {
			this.$refs["ruleForm"].validate(valid => {
				if (valid) {
					this.param.bo.startTime = this.param.bo.dateRange[0];
					this.param.bo.endTime = this.param.bo.dateRange[1];
					this.param.bo.tecFieldFirst = this.tecChecked[0];
					this.param.bo.tecFieldSecond = this.tecChecked[1];
					this.param.bo.tecFieldThird = this.tecChecked[2];
					this.param.fileBindVOList = [
						{ moduleType: 37 },
						{ moduleType: 38 },
						{ moduleType: 39 }
					];
					this.fileList37.forEach(item => {
						this.param.fileBindVOList.push(item.response.data);
					});
					this.fileList38.forEach(item => {
						this.param.fileBindVOList.push(item.response.data);
					});
					this.fileList39.forEach(item => {
						this.param.fileBindVOList.push(item.response.data);
					});
					console.log(this.param.fileBindVOList);
					this.loading = true;
					saveProject(this.param).then(res => {
						this.loading = false;
						if (res.code == "00000") {
							this.msgSuccess("操作成功");
							sessionStorage.setItem("zt_jjkc_project_id", res.data);
							this.param.bo.id = res.data;
						}
					});
				} else {
					this.$message.error("数据不完整");
				}
			});
		},
		nextStep() {
			if (sessionStorage.getItem("zt_jjkc_project_id")) {
				// console.log(sessionStorage.getItem("zt_jjkc_project_id"))
				this.$emit("ok");
			} else {
				this.$message.error("请先填写并保存基本信息");
			}
		},
		getBaseInfo() {
			this.loading = true;
			getProject(sessionStorage.getItem("zt_jjkc_project_id")).then(res => {
				this.loading = false;
				if (res.data) {
					this.tecChecked = [];
					this.param.bo = res.data;
					this.param.bo.dateRange = [];
					this.tecChecked.push(res.data.tecFieldFirst);
					this.tecChecked.push(res.data.tecFieldSecond);
					this.tecChecked.push(res.data.tecFieldThird);
					this.param.bo.dateRange.push(res.data.startTime);
					this.param.bo.dateRange.push(res.data.endTime);
					console.log(this.param.bo);
				}
			});
			getMultiFiles({
				moduleId: sessionStorage.getItem("zt_jjkc_project_id"),
				moduleTypes: [37, 38, 39]
			}).then(res => {
				this.fileList37 = [];
				this.fileList38 = [];
				this.fileList39 = [];
				if (res.data) {
					res.data.forEach(item => {
						item.name = item.fileName;
						item.response = { data: {} };
						item.response.data.moduleType = item.moduleType;
						item.response.data.moduleId = item.moduleId;
						item.response.data.fileName = item.fileName;
						item.response.data.path = item.path;
						if (item.moduleType == 37) {
							this.fileList37.push(item);
						}
						if (item.moduleType == 38) {
							this.fileList38.push(item);
						}
						if (item.moduleType == 39) {
							this.fileList39.push(item);
						}
					});
				}
			});
		},
		init() {
			getCascadeDictData("technical_field").then(res => {
				this.tecOptions = res.data;
				if (sessionStorage.getItem("zt_jjkc_project_id")) {
					this.getBaseInfo();
				}
			});
		},
		handleRemove(file, fileList) {
			console.log(fileList);
			if (file.response.data.moduleType == 37) {
				this.fileList37 = [];
				fileList.forEach(item => {
					console.log(item);
					this.fileList37.push(item);
				});
			}
			if (file.response.data.moduleType == 38) {
				this.fileList38 = [];
				fileList.forEach(item => {
					this.fileList38.push(item);
				});
			}
			if (file.response.data.moduleType == 39) {
				this.fileList39 = [];
				fileList.forEach(item => {
					this.fileList39.push(item);
				});
			}
		},
		handlePreview(file) {},
		handleExceed(files, fileList) {
			this.$message.error("超出限制文件个数");
		},
		beforeRemove(file, fileList) {},
		uploadSuccess(res, file) {
			this.loading = false;
			this.msgSuccess("上传成功");
			let file2 = res.data;
			if (file2.moduleType == 37) {
				this.fileList37.push(file);
			}
			if (file2.moduleType == 38) {
				this.fileList38.push(file);
			}
			if (file2.moduleType == 39) {
				this.fileList39.push(file);
			}
		},
		beforeUploadZjtx(file, fileList) {
			let suffix = file.name.substring(file.name.lastIndexOf(".") + 1);
			if (suffix != "pdf" && suffix != "doc" && suffix != "docx") {
				this.$message.error("只能上传pdf/doc/docx格式的文件");
				return false;
			}
			if (file.size > 10240000) {
				this.$message.error(
					"文件最大可上传10MB,您上传的" + file.name + "已超出限制"
				);
				return false;
			}
			// this.loading = true;
		},
		uploadError() {
			this.loading = false;
		}
	}
};
</script>

<style scoped>
.text {
	font-size: 14px;
	padding: 10px 20px;
	position: relative;
	border-bottom: 1px solid #dbdbdb;
	margin-bottom: 20px;
}
.text::before {
	content: "";
	position: absolute;
	width: 4px;
	height: 18px;
	left: 10px;
	top: 10px;
	background: #7c99fd;
}
</style>
